import React, { FC } from 'react';
import {
  Button,
  ListGroup,
  Modal,
  Overlay,
  Feedback,
} from '@cubeyou-team/hx-react-components';

import translations from 'src/lang';

const lang = 'en-US';

interface RemoveDestinationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const RemoveDestinationModal: FC<RemoveDestinationModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  return (
    <Overlay isOpen={isOpen}>
      <Modal
        title={translations[lang].MODALS.REMOVE_DESTINATION.MODAL_TITLE}
        footer={
          <ListGroup
            direction="row"
            items={[
              <Button type="submit" size="small" onClick={onSuccess}>
                {translations[lang].MODALS.REMOVE_DESTINATION.BUTTON_REMOVE}
              </Button>,
              <Button size="small" variant={'outlined'} onClick={onClose}>
                {translations[lang].MODALS.REMOVE_DESTINATION.BUTTON_CANCEL}
              </Button>,
            ]}
          />
        }
        closable
        handleClose={onClose}
      >
        <Feedback
          message={translations[lang].MODALS.REMOVE_DESTINATION.MODAL_CONTENT}
          status="warning"
        />
      </Modal>
    </Overlay>
  );
};
